import querystring from 'query-string';

export default function getUrlWrapTestCode(url) {
    const { test_code, test_expired } = querystring.parse(window.location.search);
    const queryConnectStr = url.indexOf('?') === -1 ? '?' : '&';

    const testQueryStrings =
        Boolean(test_code) && Boolean(test_expired)
            ? `${queryConnectStr}test_code=${test_code}&test_expired=${test_expired}`
            : '';
    return `${url}${testQueryStrings}`;
}
